import {createContext, useContext} from 'react';
import type {Branding} from '@/types/branding';

interface AuthBrandingContextType {
    branding: Branding;
}

const AuthBrandingContext = createContext<AuthBrandingContextType | null>(null);

export function AuthBrandingProvider({
    children,
    branding,
}: {
    children: React.ReactNode;
    branding: Branding;
}) {
    return (
        <AuthBrandingContext.Provider value={{branding}}>
            {children}
        </AuthBrandingContext.Provider>
    );
}

export function useAuthBranding() {
    const context = useContext(AuthBrandingContext);

    if (context === null) {
        throw new Error(
            'useAuthBranding must be used within AuthBrandingProvider'
        );
    }

    return context;
}
